<template>
  <div class="contractManagement-addLease-dialog">
    <custom-dialog
      width="1400px"
      :title="model.title"
      :visible="visible"
      v-on="$listeners"
    >
      <div class="dialog-body">
        <div class="product-wrap">
          <div class="search-container">
            <el-form :inline="true" label-position="top">
              <el-form-item>
                <template slot="label">
                  <span class="required-label">{{ $t('crm_contractManagement_addLease_dialog.chan_pin_xing_hao') }}</span>
                </template>
                <custom-select
                  :disabled="model.type === 'date_end_continue'"
                  v-model="formSearch.productCode"
                  url="productCodeSelectList"
                  :props="{ label: 'productName', value: 'productCode' }"
                  @change="onProductCodeChange"
                  :placeholder="$t('Common.com_please_select')"
                  reserveKeyword
                  width="100%"
                ></custom-select>
              </el-form-item>
              <el-form-item :label="$t('crm_contractManagement_addLease_dialog.zu_lin_yue_shu')">
                <el-input
                  :min="1"
                  type="number"
                  v-model="formSearch.rentalTerms"
                  style="width: 100%"
                  @input="getLessee()"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm_contractManagement_addLease_dialog.zu_lin_dan_wei')">
                <!-- deviceBizType :disabled="model.type === 'date_end_continue'"-->
                <custom-select
                 :disabled="true"
                  v-model="formSearch.rentalTermUnit"
                  code="rental_term_unit"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                ></custom-select>
              </el-form-item>
              <el-form-item  :label="$t('crm_contractManagement_addLease_dialog.she_bei_lei_xing')">
                <!-- deviceBizType -->
                <custom-select
                  :disabled="model.type === 'date_end_continue'"
                  v-model="formSearch.deviceBizType"
                  code="dms_device_biz_type"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                ></custom-select>
              </el-form-item>
              <el-form-item :label="$t('crm_contractManagement_addLease_dialog.zhi_fu_zhou_qi')">
                <custom-select
                  v-model="formSearch.paymentPeriod"
                  code="crm_payment_period"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                ></custom-select>
              </el-form-item>
              <el-form-item :label="$t('crm_contractManagement_addLease_dialog.zhi_fu_jie_dian')">
                <custom-select
                 :disabled="true"
                  v-model="formSearch.paymentNode"
                  code="payment_node"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                ></custom-select>
              </el-form-item>
              <el-form-item :label="$t('crm_contractManagement_addLease_dialog.zeng_song_hao_cai')">
                <custom-select
                  v-model="formSearch.isPartGiveaway"
                  code="isynergy_cloud_bool"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                ></custom-select>
              </el-form-item>
              <el-form-item :label="$t('crm_contractManagement_addLease_dialog.zeng_song_yue_shu')">
                <custom-select
                  v-model="formSearch.isMonthGiveaway"
                  code="isynergy_cloud_bool"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                ></custom-select>
              </el-form-item>
            </el-form>
            <div class="advanced-footer">
              <div class="button-group">
                <el-button @click="clear">{{$t('Common.com_clear')}}</el-button>
                <el-button type="primary" @click="getLessee"> {{$t('Common.com_query')}} </el-button>
              </div>
            </div>
          </div>
          <div class="table-bd">
            <custom-table
              ref="table"
              type="radio"
              :data="rentLsseeList"
              v-model="leaseListSelect"
              :loading="isLoading"
              :column="tableColumn"
              @filter="filterChange"
              @sort="sortChange"
              height="500px"
              :slots="['rentalTerm']"
            >
              <template slot="rentalTerm" slot-scope="scope">
                <span
                  >{{ scope.row.rentalTermMin }} -
                  {{ scope.row.rentalTermMax }}</span
                >
              </template>
            </custom-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{
          $t('Common.com_cancel')
        }}</el-button>
        <el-button type="primary" @click="saveChoose">{{
          $t('Common.com_confirm')
        }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableCode: 'contract_choose_sku',
      rentLsseeList: [],
      isLoading: false,
      formSearch: {
        productCode: '',
        deviceBizType: '', // 设备业务类型，字典分组代码：dms_device_biz_type
        rentalTermUnit: 'M', // 租赁单位，字典分组代码：rental_term_unit
        rentalTerms: '', // 租赁月/周/日数
        paymentPeriod: '', // 支付周期，字典分组代码：crm_payment_period
        paymentNode: '1', // 付款时间节点，字典分组代码：payment_node
        pageNum: 1,
        pageSize: 50,
        bigCustomerId: '',
        isPartGiveaway: '',
        isMonthGiveaway: '',
      },
      leaseListSelect: {},
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.initDialog();
    this.getLessee();
    this.getTableColumn();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.formSearch.bigCustomerId = this.model.bigCustomerId;
      if (this.model.type === 'date_end_continue') {
        this.$setFormatData(this.formSearch, this.model.row);
      }
      this.formSearch.rentalTerms = this.model.rentalTerms;
      if (this.model.row) {
        this.formSearch.deviceBizType = this.model.row.nextDeviceBizType || '';
      }
    },
    // 产品型号变更时，自动触发查询
    onProductCodeChange: function () {
      this.getLessee();
    },
    // 获取关联列表
    getLessee: function () {
      this.$getJSON(apis.rmsGoodsSelectSkuList, this.formSearch).then((res) => {
        this.rentLsseeList = res.data;
      });
    },
    clear: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      if (this.model.type === 'date_end_continue') {
        this.formSearch.productCode = this.model.row.productCode;
      }
      this.getLessee();
    },
    // 保存新增
    saveChoose: function () {
      if (!this.formSearch.productCode) {
        this.$message({
          message: this.$t('crm_contractManagement_addLease_dialog.qxzcpxh'),
          type: 'error',
        });
        return;
      }
      if (!this.leaseListSelect.goodsSkuId) {
        this.$message({
          message: this.$t('crm_contractManagement_addLease_dialog.qing_xuan_ze_fang_an'),
          type: 'error',
        });
        return;
      }
      if (!this.formSearch.rentalTerms || +this.formSearch.rentalTerms < 0) {
        this.$message({
          message: this.$t('crm_contractManagement_addLease_dialog.qsrzlys'),
          type: 'error',
        });
        return;
      }
      if (+this.formSearch.rentalTerms < +this.leaseListSelect.paymentPeriod) {
        this.$message({
          message: this.$t('crm_contractManagement_addLease_dialog.zlysydyzfzq'),
          type: 'error',
        });
        return;
      }
      // productCode 以搜索区选择的为准（避免表格行数据不一致）
      const selectRow = {
        ...this.leaseListSelect,
        productCode: this.formSearch.productCode,
      };
      this.$emit('success', [selectRow], this.formSearch.rentalTerms);
      this.visible = false;
    },
  },
};
</script>

<style lang="scss">
.contractManagement-addLease-dialog {
  .search-container {
    padding: 0px 8px 8px;
    margin-bottom: 16px;
    background: #f6f6fa;
    border-radius: 2px;
    overflow: hidden;
    // overflow: hidden;
    .el-form-item {
      // width: 14.2%;
      width: 25%;
      margin: 0 !important;
      margin-bottom: 0px !important;
      padding: 0 8px;
      .el-input__inner {
        border: none !important;
      }
    }
    > .advanced-footer {
      overflow: hidden;
      margin-top: 10px;
      .button-group {
        margin-right: 8px;
        margin-bottom: 8px;
        margin-top: 8px;
        float: right;
      }
    }
    .el-input-group__prepend {
      background-color: #ffffff;
      border: none;
      .el-select {
        vertical-align: baseline !important;
      }
    }

    .el-input.is-disabled .el-input__inner {
      background-color: #fcfcfc;
    }

    .el-form-item--small .el-form-item__label {
      margin-top: 16px;
      font-size: 12px;
      padding: 0px 0px 4px 0 !important;
      color: #495057;
      line-height: 24px;
    }

    /* 必选红星（不引入整套 el-form rules，改动最小） */
    .required-label {
      position: relative;
      padding-left: 8px;

      &::before {
        content: '*';
        position: absolute;
        left: 0;
        top: -5px;
        color: #f56c6c;
      }
    }
  }
}
</style>
